import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import i18n from "@/plugins/i18n";
import utility from "@/plugins/utility";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueNumber from "vue-number-animation";
import VueSmoothScroll from "vue2-smooth-scroll";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { VueMasonryPlugin } from "vue-masonry";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import
	{
		Swiper as SwiperClass,
		Pagination,
		Navigation,
		Mousewheel,
		Autoplay
	} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.css";
import Chartkick from "vue-chartkick";
import Chart from "chart.js";
import "./registerServiceWorker";
//import Mgr from "./oidc/SecurityService";

library.add(fas);
library.add(fab);
library.add(far);

Vue.use(VueNumber);
Vue.use(IconsPlugin);
Vue.use(BootstrapVue);
Vue.use(VueMasonryPlugin);
SwiperClass.use([Pagination, Mousewheel, Navigation, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueSmoothScroll, { duration: 900, offset: -50 });
Vue.component("date-picker", VuePersianDatetimePicker);
Vue.use(Chartkick.use(Chart));
Vue.config.productionTip = true;

window.axios = axios;
axios.defaults.baseURL = "https://api.ramnicpay.com/";
//axios.defaults.baseURL =
//	location.hostname === "localhost" || location.hostname === "127.0.0.1"
//		? "https://localhost:44380"
//		: "https://api.ramnicpay.com/";

Chart.defaults.global.defaultFontFamily = "IRANSansWeb";
Chart.defaults.global.defaultFontSize = 10;



var __db =
	new utility.db();

if (__db.select("__t") != null)
{
	var __cart = __db.select("cart");

	if (
		localStorage.getItem("__c") != "undefined" &&
		localStorage.getItem("__c") != undefined
	)
	{
		store.token = __db.select("__t");
		store.customer = __db.select("__c");
	}

	if (store.token != null)
	{
		axios.defaults.headers.common["Authorization"] =
			"Bearer " + store.token.access_token;
	}

	if (__cart && __cart.dt && Date.now() - __cart.dt < 86400000)
	{
		store.cart = __db.select("cart");
	} else __db.delete("cart");
}
else
{
	__db.delete("__t");
	__db.delete("__c");
}


//var mgr = new Mgr();

//mgr.getUserWithoutSignin().then(function(user) {
//	var __db;
//	__db = new utility.db();

//	if (user != null) {
//		if (__db.select("__t") != null) {
//			var __cart = __db.select("cart");

//			if (
//				localStorage.getItem("__c") != "undefined" &&
//				localStorage.getItem("__c") != undefined
//			) {
//				store.token = __db.select("__t");
//				store.customer = __db.select("__c");
//			}

//			if (store.token != null) {
//				axios.defaults.headers.common["Authorization"] =
//					"Bearer " + store.token.access_token;
//			}

//			if (__cart && __cart.dt && Date.now() - __cart.dt < 86400000) {
//				store.cart = __db.select("cart");
//			} else __db.delete("cart");
//		}
//	} else {
//		__db.delete("__t");
//		__db.delete("__c");
//	}
//});

new Vue({
	created()
	{
		AOS.init();
	},
	i18n,
	utility,
	router,
	render: h => h(App)
}).$mount("#app");
